import { styled } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../styledFilter';

export const FormControlContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	textAlign: 'left',
});

export const InputLabelComponent = styled('label')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-label-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-text-primary)',
	marginBottom: 10,
});

export const InputError = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-error)',
	margin: 0,
});

export const SelectInput = styled(domTag('select', ['iserror', 'isvalid', 'customwidth']))(({
	iserror,
	isvalid,
	customwidth,
}: {
	iserror?: string;
	isvalid?: boolean;
	customwidth?: string | number;
}) => {
	const getBorderColor = () => {
		if (iserror) return 'var(--color-error)';
		if (isvalid) return 'var(--color-success)';
		return 'var(--color-border-default)';
	};

	return {
		'fontFamily': 'var(--font-family-regular)',
		'fontSize': 'var(--text-body-size)',
		'outline': 'none',
		'borderRadius': 'var(--radius-default)',
		'height': 40,
		'paddingLeft': 10,
		'paddingRight': 32,
		'maxWidth': customwidth || 320,
		'width': '100%',
		'backgroundColor': 'var(--color-bg-primary)',
		'color': 'var(--color-text-primary)',
		'border': `1px solid ${getBorderColor()}`,
		'cursor': 'pointer',
		'transition':
			'border-color var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast)',
		'appearance': 'none',
		'backgroundImage':
			"url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23626262' d='M6 8L1 3h10z'/%3E%3C/svg%3E\")",
		'backgroundRepeat': 'no-repeat',
		'backgroundPosition': 'right 12px center',
		'&:hover:not(:focus):not(:disabled)': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-strong)',
		},
		'&:focus': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-focus)',
			boxShadow: iserror
				? '0 0 0 3px var(--color-error-bg)'
				: isvalid
					? '0 0 0 3px color-mix(in srgb, var(--color-success) 20%, transparent)'
					: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 20%, transparent)',
		},
		'&:disabled': {
			backgroundColor: 'var(--color-bg-tertiary)',
			color: 'var(--color-text-disabled)',
			cursor: 'not-allowed',
		},
		[down('md')]: {
			minWidth: 0,
			maxWidth: '100%',
			height: 48,
			fontSize: '15px',
		},
	};
});
